import { render, staticRenderFns } from "./ShopOrderPayment.vue?vue&type=template&id=e9827fac&scoped=true&"
import script from "./ShopOrderPayment.vue?vue&type=script&lang=js&"
export * from "./ShopOrderPayment.vue?vue&type=script&lang=js&"
import style0 from "./ShopOrderPayment.vue?vue&type=style&index=0&id=e9827fac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9827fac",
  null
  
)

export default component.exports